import { IconProps } from "../../utils/global-types/global-types";

const LaunchIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M15.925 2.197a.16.16 0 0 0-.11-.116c-1.83-.447-6.06 1.147-8.35 3.438q-.615.61-1.112 1.315c-.706-.062-1.413-.01-2.016.253-1.7.747-2.194 2.7-2.334 3.538a.3.3 0 0 0 .247.347q.042.006.084.003l2.728-.3q.005.31.038.615c.012.141.078.276.178.376l1.056 1.053c.1.1.234.165.375.178q.303.033.613.037l-.3 2.725a.3.3 0 0 0 .35.328c.837-.134 2.793-.628 3.537-2.328.263-.603.316-1.306.256-2.01a10 10 0 0 0 1.32-1.112c2.296-2.284 3.88-6.418 3.44-8.34m-3.616 5.612a1.497 1.497 0 0 1-2.119 0 1.5 1.5 0 0 1 0-2.122A1.5 1.5 0 1 1 12.31 7.81"
    ></path>
    <path
      fill="currentColor"
      d="M6.262 13.481c-.172.172-.447.238-.778.297-.744.125-1.4-.515-1.266-1.265.05-.285.204-.685.297-.779a.14.14 0 0 0 .003-.193.13.13 0 0 0-.115-.04c-.416.05-.803.24-1.097.533-.738.738-.806 3.466-.806 3.466s2.73-.069 3.465-.806c.297-.297.485-.681.535-1.1.012-.128-.147-.206-.238-.113"
    ></path>
  </svg>
);

export default LaunchIcon;
